import { z } from 'zod';
import {
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const openProtocolConnectionCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('openProtocolConnection'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface OpenProtocolConnectionCfgSchema extends z.infer<typeof openProtocolConnectionCfgSchema> {}

export const openProtocolConnectionSocketCfg = {
    controlSockets: {
        outputs: () => {
            // const ret: Record<'midReceieved', ControlSocketKind> = {
            //     midReceieved: 'event',
            // };
            return {};
        },
        inputs: () => {
            return {};
        },
    },
    dataSockets: {
        outputs: () => {
            // const ret: {
            //     midOutput: 'number';
            //     dataOutput: 'varValue';
            // } = {
            //     midOutput: 'number',
            //     dataOutput: 'varValue',
            // };
            return {};
        },
        inputs: () => {
            return {};
        },
    },
} satisfies NodeSocketCfg<OpenProtocolConnectionCfgSchema>;
